<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstVisitorPassDetail"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedVisitorPassDetail"
		dataKey="VisitorPassDetailID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--HasPhotoDesc-->
				<th class="ImageCol">
					<!-- <p-columnFilter field="HasPhotoDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterHasPhotoDesc [ngModel]="value" [options]="lstHasPhotoDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LogDT-->
				<th>
					<!-- <p-columnFilter type="text" field="LogDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--FacilityLocationName-->
				<th>
					<p-columnFilter field="FacilityLocationName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterFacilityLocationName
								[ngModel]="value"
								[options]="lstFacilityLocationName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th class="ImageCol" pSortableColumn="HasPhotoDesc">Photo<p-sortIcon field="HasPhotoDesc"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="LogDT">Date/Time<p-sortIcon field="LogDT"></p-sortIcon></th>
				<th pSortableColumn="FacilityLocationName">Location<p-sortIcon field="FacilityLocationName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-VisitorPassDetail>
			<tr [pSelectableRow]="VisitorPassDetail" (dblclick)="onRowDblClick(VisitorPassDetail)">
				<td class="ImageCol">
					<a
						[id]="'Link' + VisitorPassDetail.VisitorPassDetailID"
						style="display: none"
						[routerLink]="VisitorPassDetail.RouterLink"
						target="_blank"
					></a>
					<img class="VisitorImage" [src]="GetPhotoData(VisitorPassDetail.VisitorPassID)" />
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPassDetail[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
